export const getSlab = () => {
  if (window.pledgeMoreSlab !== undefined) {
    return window.pledgeMoreSlab;
  }
};

export const getActivationType = () => {
  if (window.activationType !== undefined) {
    return window.activationType;
  }
};

export const getGiftingType = () => {
  if (window.referralType !== undefined) {
    return window.referralType;
  }
};

export const getLatestUpdatePanel = () => {
  if (window.latestUpdate !== undefined) {
    return window.latestUpdate;
  }
};

export const getMultiPitchSIP = () => {
  if (window.multiPitchSIP !== undefined) {
    return window.multiPitchSIP;
  }
};

export const getNotMedicalSIP = () => {
  if (window.notMedicalSIP !== undefined) {
    return window.notMedicalSIP;
  }
};

export const getCauseAmount = () => {
  if (window.causeAmount !== undefined) {
    return window.causeAmount;
  }
};

export const getBundleCauses = () => {
  if (window.bundleCause !== undefined) {
    return window.bundleCause;
  }
};
